const ENGoalManagement = {
	"O campo meta padrão e % de crescimento devem estar preenchidos":"Default goal and grow rate Fields must be a value",
	"% de crescimento":"Grow rate",
	"Calcular":"Calculate",
	"Coloca a meta padrão no primeiro período e calcula os seguintes conforme o % de crescimento informado":"The default goal will be put on the first period, the others will be calculated using the informed grow rate",
	"Metas por período":"Goals by periods",
	"Erro ao buscar valores de metas":"Error on search goal's values",
	"Erro ao alterar valores de metas": "Error changing goal's values",
	"Metas alteradas com sucesso":"goals successfully changed"
};

export default ENGoalManagement;
